import {Button, ButtonState} from "@nolimitcity/slot-game/bin/core/component/Button";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TimelineLite, TimelineMax, TweenLite} from "gsap";
import {SoundManager} from "../../resource/sound/SoundManager";

export class PickButton extends Button {
    private _smokeAnimation: PIXI.spine.Spine;
    private _animation: PIXI.spine.Spine;
    private _keyword: string;
    private _idleTl: TimelineMax | null;
    private isPlayingMouseOver: boolean = false;
    private _fsNumberAnimation: PIXI.spine.Spine;
    private _fsNumberAnimationMayhem: PIXI.spine.Spine;
    private _numberOfFS: number;
    private _isMayhemTriggered: boolean = false;

    constructor(keyword: string, onClickedCallback: () => void) {
        super({
            idle: PIXI.Texture.EMPTY,
            over: PIXI.Texture.EMPTY,
            down: PIXI.Texture.EMPTY,
            disabled: PIXI.Texture.EMPTY,
        }, onClickedCallback, 15);
        this._keyword = keyword;
        this.name = keyword;
    }

    public createAnimation(): void {
        this._smokeAnimation = new PIXI.spine.Spine(GameResources.getSpineAsset(this._keyword + "Smoke"));
        this._smokeAnimation.visible = false;
        this._smokeAnimation.scale.set(0.8);

        this._animation = new PIXI.spine.Spine(GameResources.getSpineAsset(this._keyword));
        this._animation.visible = false;

        this._fsNumberAnimation = new PIXI.spine.Spine(GameResources.getSpineAsset(this._keyword + "FSNumber"));
        this._fsNumberAnimation.visible = false;

        this._fsNumberAnimationMayhem = new PIXI.spine.Spine(GameResources.getSpineAsset(this._keyword + "Mayhem"));
        this._fsNumberAnimationMayhem.visible = false;

        this.addChild(this._smokeAnimation, this._animation, this._fsNumberAnimation, this._fsNumberAnimationMayhem);
    }

    public setState(state: ButtonState, autoPlay?: boolean): void {
        super.setState(state, false);

        switch (state) {
            case ButtonState.over:
                this.playMouseOver();
                break;
            case ButtonState.idle:
                this.playMouseOut();
                break;
            case ButtonState.down:
                this.playMouseDown();
                break;
            default:
            // do nothing.
        }
    }

    public reset(): void {
        if (this._animation) {
            this.hide();
            this._animation.tint = 0xffffff;
            this._fsNumberAnimationMayhem.tint = 0xffffff;
            this._smokeAnimation.tint = 0xffffff;
            this._fsNumberAnimation.tint = 0xffffff;
        }
        if (this._idleTl) {
            if (this._idleTl.isActive()) {
                this._idleTl.pause();
                this._idleTl.kill();
            }
            this._idleTl = null;
        }
    }

    public show(numberOfFS: number, isMayhemTriggered: boolean): void {
        const tl: TimelineLite = new TimelineLite();

        // #438
        this._numberOfFS = numberOfFS;
        this._isMayhemTriggered = isMayhemTriggered;

        tl.add(() => {
            // #410
            SoundManager.playFSSelectFadein();

            this.resetSpineItem(this._smokeAnimation);
            this._smokeAnimation.state.setAnimation(0, this._keyword + "_Loop", true);

            this.resetSpineItem(this._animation);
            this._animation.state.setAnimation(0, this._keyword + "_Start", false);

            if (isMayhemTriggered) {
                this.resetSpineItem(this._fsNumberAnimationMayhem);
                this._fsNumberAnimationMayhem.state.setAnimation(0, (this._keyword.replace("fs", "mayhem")) + "_Start", false);
            } else {
                this.resetSpineItem(this._fsNumberAnimation);
                this._fsNumberAnimation.state.setAnimation(0, this._keyword + "_Start_" + numberOfFS, false);
            }
        });
    }

    public playIdel(): void {
        if (this._animation) {
            this._idleTl = new TimelineMax({repeat: -1, repeatDelay: 1});
            this._idleTl.add(() => this.playGlow(), "+=1");
            //1 is duration of Loop Animation;both left-right
            //right animation is repeated after completion of left animation(after 1sec)
            //#363
        }
    }

    public playClick(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => this.playGlow());
        tl.add(() => {
        }, 1);
        return tl;
    }

    public playUnselectedTint(): TweenLite {
        return TweenLite.to([this._animation, this._fsNumberAnimationMayhem, this._smokeAnimation, this._fsNumberAnimation], 0.001, {tint: 0x555555});
    }

    protected init(): void {
        super.init();
        this.interactiveChildren = false;
        this.hitArea = new PIXI.Rectangle(-190, -240, 380, 480);
    }

    private playGlow(): void {
        const btn = this.parent.children[this.parent.children.length - 1]! as PickButton;
        const btn2 = this.parent.children[this.parent.children.length - 2]! as PickButton;
        if (this.isPlayingMouseOver) {
            if (btn.isPlayingMouseOver && btn._keyword !== this._keyword) {
                /*to glow other option which is not mouseOvered*/
                btn.isPlayingMouseOver = false;
            }

            if (btn2.isPlayingMouseOver && btn2._keyword !== this._keyword) {
                /*to glow other option which is not mouseOvered*/
                btn2.isPlayingMouseOver = false;
            }

            return;
        }

        this._animation.state.setAnimation(0, this._keyword + "_Loop", false);
        if (this._isMayhemTriggered) {
            this.resetSpineItem(this._fsNumberAnimationMayhem);
            this._fsNumberAnimationMayhem.state.setAnimation(0, (this._keyword.replace("fs", "mayhem")) + "_Loop", false);
        } else {
            this.resetSpineItem(this._fsNumberAnimation);
            this._fsNumberAnimation.state.setAnimation(0, this._keyword + "_Loop_" + this._numberOfFS, false);
        }
    }

    private playMouseOut(): void {
        if (!this.parent || this.parent!.children!.length < 5 && !this.isPlayingMouseOver) {
            return;
        }
        const btn = this.parent.children[this.parent.children.length - 1]! as PickButton;
        const btn2 = this.parent.children[this.parent.children.length - 2]! as PickButton;
        btn.isPlayingMouseOver = false;
        btn2.isPlayingMouseOver = false;

        TweenLite.to(this._smokeAnimation.scale, 0.266, {x: 0.8, y: 0.8});

        this._animation.state.setAnimation(0, this._keyword + "_Mout", false);
        if (this._isMayhemTriggered) {
            this.resetSpineItem(this._fsNumberAnimationMayhem);
            this._fsNumberAnimationMayhem.state.setAnimation(0, (this._keyword.replace("fs", "mayhem")) + "_Mout", false);
        } else {
            this.resetSpineItem(this._fsNumberAnimation);
            this._fsNumberAnimation.state.setAnimation(0, this._keyword + "_Mout_" + this._numberOfFS, false);
        }
    }

    private playMouseOver(): void {
        if (this.isPlayingMouseOver) {
            return
        }
        this.isPlayingMouseOver = true;

        TweenLite.to(this._smokeAnimation.scale, 0.266, {x: 0.9, y: 0.9});

        this._animation.state.setAnimation(0, this._keyword + "_Mover", false);
        if (this._isMayhemTriggered) {
            this.resetSpineItem(this._fsNumberAnimationMayhem);
            this._fsNumberAnimationMayhem.state.setAnimation(0, (this._keyword.replace("fs", "mayhem")) + "_Mover", false);
        } else {
            this.resetSpineItem(this._fsNumberAnimation);
            this._fsNumberAnimation.state.setAnimation(0, this._keyword + "_Mover_" + this._numberOfFS, false);
        }
    }

    private playMouseDown(): void {
        this.isPlayingMouseOver = false;
        this._animation.state.setAnimation(0, this._keyword + "_Picked", false);
        if (this._isMayhemTriggered) {
            this.resetSpineItem(this._fsNumberAnimationMayhem);
            this._fsNumberAnimationMayhem.state.setAnimation(0, (this._keyword.replace("fs", "mayhem")) + "_Picked", false);
        } else {
            this.resetSpineItem(this._fsNumberAnimation);
            this._fsNumberAnimation.state.setAnimation(0, this._keyword + "_Picked_" + this._numberOfFS, false);
        }
    }

    private resetSpineItem(item: PIXI.spine.Spine): void {
        if (!item.visible) {
            item.updateTransform();
            item.visible = true;
        }

        item.state.clearTracks();
        item.state.setEmptyAnimation(0, 0);
        item.skeleton.setSlotsToSetupPose();
        item.skeleton.setToSetupPose();
    }

    private hide(): void {
        this._smokeAnimation.visible = false;
        this._smokeAnimation.state.clearTracks();

        this._animation.visible = false;
        this._animation.state.clearTracks();

        this._fsNumberAnimation.visible = false;
        this._fsNumberAnimation.state.clearTracks();

        this._fsNumberAnimationMayhem.visible = false;
        this._fsNumberAnimationMayhem.state.clearTracks();
    }
}